var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.fields),function(field){return _c(_vm.getFieldComponent(field.type),{key:field.name,tag:"component",attrs:{"parentData":{ grid: _vm.grid, data: _vm.getFieldData(field), allFields: _vm.fields }},on:{"fields-loaded":_vm.fieldsLoaded,"fieldIsForbidden":_vm.fieldIsForbidden}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }